import BulletIcon from "../../../assets/Bullet/bullet.svg";
import type { ProductGroup } from "../../../types";

export const bullet: ProductGroup = {
  id: "bullet",
  title: "bullet.title",
  icon: {
    src: BulletIcon,
    width: 51,
    height: 38,
  },
};
